import { useGetBuyerContactData } from '@/hooks/buyers/useGetBuyerContactData';
import { buyerContactDataResponseToBusinessDataUi } from '@/hooks/buyers/useGetBuyerContactData/mapper';
import { useUpdateBuyerContactData } from '@/hooks/buyers/useUpdateBuyerContactData';
import { WritableDraft } from 'immer';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { BusinessDataUi, initialState } from './BusinessDataUi';

export function useBusinessDataViewController() {
  const [uiState, setUiState] = useImmer<BusinessDataUi>(initialState);
  const buyerId = useParams().buyerId;
  const { data } = useGetBuyerContactData(buyerId);
  const savedDataUiRef = useRef<BusinessDataUi>();
  const updateBuyerContactDataHook = useUpdateBuyerContactData();

  useEffect(() => {
    if (!data) return;
    const newUiState = buyerContactDataResponseToBusinessDataUi(data);
    savedDataUiRef.current = newUiState;
    setUiState(newUiState);
  }, [data]);

  const onBusinessNameChanged = (newName: string) =>
    setUiState((draft) => {
      draft.businessName = newName;
      draft.businessNameError = !draft.businessName.trim()
        ? 'Nombre inválido'
        : undefined;
      draft.cancelDisabled = false;
      calculateContinueState(draft);
    });

  const calculateContinueState = (draft: WritableDraft<BusinessDataUi>) => {
    draft.saveDisabled = !draft.businessName;
  };

  const onClickedCancel = () =>
    setUiState(savedDataUiRef.current ?? initialState);

  const onClickedSave = () => {
    if (!buyerId) return;
    updateBuyerContactDataHook.mutate({
      buyerId,
      data: { businessName: uiState.businessName },
    });
  };

  return {
    uiState,
    actions: { onBusinessNameChanged, onClickedCancel, onClickedSave },
  };
}
